import { render, staticRenderFns } from "./CargoCrudStatusDisapproved.vue?vue&type=template&id=307e2ae6"
import script from "./CargoCrudStatusDisapproved.vue?vue&type=script&lang=js"
export * from "./CargoCrudStatusDisapproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports